export default __webpack_public_path__ + "static/media/CellFree_Recombinant.59ca3532.svg";